











































import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../../main/components/nav-left/nav-left.vue";
import MenzhenEdit from "../../components/zhenliaojilu/menzhen-edit.vue";
import ZhuyuanEdit from "../../components/zhenliaojilu/zhuyuan-edit.vue";
Component.registerHooks([
  "beforeRouteEnter",
  "beforeRouteLeave",
  "beforeRouteUpdate",
]);
@Component({
  components: {
    MainHeader,
    NavLeft,
    MenzhenEdit,
    ZhuyuanEdit,
  },
})
export default class Name extends Vue {
  private routerPath: any = "";
  private type: any = "";
  private id: any = "";
  private ifShowSaveConfirm: any = false;
  private noSaveText: any = "不保存，离开";

  private get patient() {
    return this.$store.state.patient;
  }
  private get ifCompose() {
    return this.$store.state.ifCompose;
  }

  private forceUpdate() {
    this.$forceUpdate();
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to: any, from: any, next: any) {
    this.routerPath = to.fullPath;
    if (this.ifCompose) {
      this.ifShowSaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
  private mounted() {
    if (this.$route.query.type) {
      this.type = this.$route.query.type;
    }
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
  }
}
